import React from "react";

interface PriceLockProps {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  className?: string;
}

const PriceLock = ({ color = "#FF0037", width = 16, height = 16, style, className }: PriceLockProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M16.0001 0.666748L20.6667 4.00008L16.0001 7.33341V5.33341H13.3334C8.91514 5.33341 5.33341 8.91514 5.33341 13.3334V18.6667C5.33341 23.085 8.91514 26.6667 13.3334 26.6667H18.6667C23.085 26.6667 26.6667 23.085 26.6667 18.6667V13.3334C26.6667 9.9682 24.5889 7.08829 21.6462 5.90665L24.0813 4.14121C27.2247 5.99681 29.3334 9.41885 29.3334 13.3334V18.6667C29.3334 24.5578 24.5578 29.3334 18.6667 29.3334H13.3334C7.44238 29.3334 2.66675 24.5578 2.66675 18.6667V13.3334C2.66675 7.44238 7.44238 2.66675 13.3334 2.66675H16.0001V0.666748Z"
        fill={color}
      />
      <path
        d="M18.6667 12.0001H11.3334V9.33341H18.6667C20.5077 9.33341 22.0001 10.8258 22.0001 12.6667V14.0001C22.0001 14.7505 21.7521 15.443 21.3337 16.0001C21.7521 16.5572 22.0001 17.2497 22.0001 18.0001V19.3334C22.0001 21.1744 20.5077 22.6667 18.6667 22.6667H11.3334V20.0001H18.6667C19.0349 20.0001 19.3334 19.7016 19.3334 19.3334V18.0001C19.3334 17.6319 19.0349 17.3334 18.6667 17.3334H13.6667V14.6667H18.6667C19.0349 14.6667 19.3334 14.3683 19.3334 14.0001V12.6667C19.3334 12.2986 19.0349 12.0001 18.6667 12.0001Z"
        fill={color}
      />
    </svg>
  );
};

PriceLock.displayName = "PriceLock";

export default PriceLock;
